import React from 'react';
import { Card, CardContent, Box, Typography, Button, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AssignmentIcon from '@mui/icons-material/Assignment';

const SalesMasterCard = ({ selectedSchedule, isNewRegistration, handleResetForm, handleDisconnectSchedule }) => {
    const renderActionButtons = () => (
        <Button
            type="button"
            variant="outlined"
            color="secondary"
            size="small"
            onClick={handleResetForm}
            sx={{ 
                fontWeight: 'bold', borderColor: '#ccc', color: '#333', px: 1.5,
                '&:hover': { borderColor: '#999', backgroundColor: '#f5f5f5' }
            }}
        >
            새로 작성
        </Button>
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {selectedSchedule && !isNewRegistration ? (
                <Card elevation={0} sx={{ backgroundColor: '#e7f5ff', border: '1px solid #a5d8ff', borderRadius: '8px' }}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1 }}>
                            <BusinessIcon sx={{ color: '#228be6' }} />
                            <Box>
                                <Typography variant="caption" color="#1c7ed6" display="block" sx={{ fontWeight: 700 }}>호출 된 일정 및 활동</Typography>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#102a43' }}>{selectedSchedule.title}</Typography>
                            </Box>
                        </Box>
                        {renderActionButtons()}
                    </CardContent>
                </Card>
            ) : (
                <Card elevation={0} sx={{ backgroundColor: '#f8f9fa', border: '1px dashed #dee2e6', borderRadius: '8px' }}>
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 }, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1 }}>
                            <AddCircleOutlineIcon sx={{ color: '#adb5bd' }} />
                            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#495057' }}>
                                목록에서 일정을 선택 또는 새로운 일정을 등록하여 주세요.
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            )}
            <Accordion 
                variant="outlined" 
                sx={{ 
                    borderRadius: '6px !important', 
                    borderColor: '#dee2e6',
                    boxShadow: 'none',
                    backgroundColor: '#fafafa',
                    '&:before': { display: 'none' }
                }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: '1rem' }} />} sx={{ minHeight: '28px !important', height: 28, px: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AssignmentIcon sx={{ fontSize: '1rem', color: '#ff0000' }} />
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#ff0000', fontSize: '0.75rem' }}>
                            업무구분 기준 가이드 (클릭)
                        </Typography>
                    </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ p: 1.5, pt: 0, display: 'flex', flexDirection: 'column', gap: 0.75, backgroundColor: '#ffffff' }}>
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'block', fontSize: '0.75rem' }}>• 제안 활동</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            견적, 원가분석, 자료전달, 특정 영업건 미팅
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'block', fontSize: '0.75rem' }}>• 영업 대상 관리 활동</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            제안 활동 외 식사, 골프 등 접대 관련 활동 수행
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'block', fontSize: '0.75rem' }}>• 제안서 작성 활동</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            -
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'block', fontSize: '0.75rem' }}>• 영업 자격증 취득</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            영업 교육 이수, 영업 관련 전문 라이선스 취득 활동
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#1a1a1a', display: 'block', fontSize: '0.75rem' }}>• 문서 작성</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            PMS 시스템 등록, 관리비 정산, 보고 자료 작성 등
                        </Typography>
                    </Box>
                    <Divider />
                    {/* 💡 [교정 적용] 기존에 하나로 묶여있던 휴가와 기타 항목을 개별 필드로 전면 분리 독립 */}
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#d9480f', display: 'block', fontSize: '0.75rem' }}>• 휴가</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            연차, 반차, 경조사 휴가 등 공가 및 사가 사용에 따른 근태 처리 사항
                        </Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ py: 0.25 }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#e03131', display: 'block', fontSize: '0.75rem' }}>• 기타</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 1, fontSize: '0.725rem' }}>
                            -
                        </Typography>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default SalesMasterCard;
